/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import cn from "clsx";
import { Button, MenuItem } from "@mui/material";

/**
 * @param {object} props
 * @param {boolean} props.show
 */
const MobileMenu = (props) => {

    const { headerNavLinks, scrollToSection, show } = props;

    return (
        <div className={cn("mobile-menu", { open: show })}>
            <div className='mobile-menu-content'>
                {headerNavLinks.map((navLink) => {
                    return (
                        <MenuItem className='mobile-menu-item' key={`menu-item-${navLink.title}`}>
                            <Button onClick={() => scrollToSection(navLink.id)}>
                                {navLink.title}
                            </Button>
                        </MenuItem>
                    );
                })}
                <div className='mobile-menu-item'>
                    <Button className='take-survey-btn' variant='contained'>
                        {/* {TODO: add onClick handler to go to survey when ready} */}
                        Take Survey
                    </Button>
                </div>
            </div>
        </div>
    );
};

MobileMenu.displayName = "MobileMenu";
export { MobileMenu };
